export const amountToNumber = (amount: string) => {
    switch (amount) {
        case "AMOUNT_100":
            return 100
        case "AMOUNT_300":
            return 300
        case "AMOUNT_500":
            return 500
        default:
            return 0
    }
}
